import MasterRoleSettingForm from './MasterRoleSettingForm';

export default MasterRoleSettingForm;